import { useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, errMsg } from "../lib/api";
import { inputCls } from "./common";

function LeaderRow({ u, dir, reload }) {
  const [type, setType] = useState("gkk");
  const [id, setId] = useState("");
  const groups = u.leader_groups || [];
  const label = (g) => (g.type === "gkk" ? dir.gkks.find((x) => x.id === g.id)?.label : dir.ministries.find((x) => x.id === g.id)?.name) || g.id;
  const save = async (next) => {
    try { await api.put(`/users/${u.id}/leader-groups`, { groups: next }); toast.success("Leader groups updated"); setId(""); reload(); } catch (e) { toast.error(errMsg(e)); }
  };
  const linked = new Set(groups.filter((g) => g.type === type).map((g) => g.id));
  const opts = (type === "gkk" ? dir.gkks.map((g) => [g.id, g.label]) : dir.ministries.map((m) => [m.id, m.name])).filter(([v]) => !linked.has(v));
  return (
    <div className="py-3 border-t border-[#F0EADC] grid gap-2" data-testid={`leader-row-${u.id}`}>
      <div className="font-semibold">{u.name} <span className="text-xs text-stone-500 font-normal">{u.designation || u.email}</span></div>
      <div className="flex flex-wrap gap-2">
        {groups.map((g) => <span key={`${g.type}-${g.id}`} className="inline-flex items-center gap-1 rounded-full bg-[#F5F0E6] border border-[#E5DEC9] px-3 py-1 text-xs">{g.type === "gkk" ? "GKK" : "Ministry"}: {label(g)}<button onClick={() => save(groups.filter((x) => x !== g))} aria-label="Remove" data-testid={`leader-remove-${u.id}-${g.id}`}><X className="h-3 w-3" /></button></span>)}
        {!groups.length && <span className="text-xs text-stone-400">No group linked yet</span>}
      </div>
      <div className="flex flex-wrap gap-2">
        <select className={`${inputCls} h-10 w-auto`} value={type} onChange={(e) => { setType(e.target.value); setId(""); }} data-testid={`leader-type-${u.id}`}><option value="gkk">GKK</option><option value="ministry">Ministry</option></select>
        <select className={`${inputCls} h-10 w-auto max-w-xs`} value={id} onChange={(e) => setId(e.target.value)} data-testid={`leader-group-${u.id}`}><option value="">Select</option>{opts.map(([v, l]) => <option key={v} value={v}>{l}</option>)}</select>
        <button className="btn-sm btn-primary" disabled={!id} onClick={() => save([...groups, { type, id }])} data-testid={`leader-add-${u.id}`}>Link group</button>
      </div>
    </div>
  );
}

export function LeaderGroupsEditor({ users, dir, reload }) {
  return (
    <section className="sfap-card p-5" data-testid="leader-groups-editor">
      <h2 className="font-serif font-bold">3 · Link leaders to their GKK or Ministry</h2>
      <p className="text-xs text-stone-500 mb-2">A linked leader can see their group's attendance trend and download its member list (names only, no contact details) from their monitoring portal. This is separate from meeting authorizations.</p>
      {users.map((u) => <LeaderRow key={u.id} u={u} dir={dir} reload={reload} />)}
      {!users.length && <p className="text-sm text-stone-400">Create a monitor account first.</p>}
    </section>
  );
}
